module.exports = __webpack_public_path__ + "img/161.0c874829.jpg";